export default "__VITE_ASSET__DhZqVZTR__"